import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

const useUrlParams = () => {
  const {search} = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const queryObject = {};

    params.forEach((value, key) => {
      queryObject[key] = value;
    });

    const solutionType = params.get('solutionType');
    queryObject.isUrlSimulation = solutionType === 'AESTHETIC_SIMULATION';
    queryObject.isUrlSkinAnalysis = solutionType === 'SKIN_ANALYSIS';

    return queryObject;
  }, [search]);
};

export default useUrlParams;
